import {
  DescriptionOptionField,
  DraperyItemDetailsFields,
  DraperyItemDetailsFieldsAction,
} from '../../../redux/modules/my-shop/drapery-item-details-fields-reducer';
import React, { ChangeEvent, Dispatch, FC } from 'react';
// import DetailsPreview from './details-preview';
import Checkbox from "../../../ui_components/checkbox/checkbox";

interface DetailsDescriptionProps {
  title: string;
  subTitle: string;
  optionsGroupName: string;
  draperyItemDetailsFields: DraperyItemDetailsFields;
  dispatch: Dispatch<DraperyItemDetailsFieldsAction>;
  isEstimateSettingsReadOnly?: boolean;
}
interface OptionsCompProps {
  title: string;
  subTitle: string;
  optionsGroupName: string;
  draperyItemDetailsFields: DraperyItemDetailsFields;
  dispatch: Dispatch<DraperyItemDetailsFieldsAction>;
  isEstimateSettingsReadOnly?: boolean;
}

// const indexMap: Record<string, string> = {
//   'Functionality and Style': '1',
//   'Width and Length': '2',
//   'Window Mount and Board Mount': '3',
//   'If Back Valance Selected': '3',
//   'If Front Valance and Sides Selected': '4',
//   'If Bottom Skirt Selected': '4',
//   'If Lining and Interlining Selected': '5, 6',
//   'Lining and Interlining Names': '7, 8',
//   'Embellishments Selected': '9',
// };

const OptionsComp: FC<OptionsCompProps> = ({
  title,
  subTitle,
  optionsGroupName,
  draperyItemDetailsFields,
  dispatch,
  isEstimateSettingsReadOnly,
}) => {
  const optionDescriptionGroup = `${optionsGroupName}DescriptionSettings`;
  const options = draperyItemDetailsFields[optionDescriptionGroup];
  let lastGroupText: string | undefined;

  const toggleCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
    if (isEstimateSettingsReadOnly) {
      return;
    }

    const fieldId = e.currentTarget.id;
    const optionsUpdated = options.map((i: DescriptionOptionField) => {
      const { id } = i;
      if (id === fieldId) {
        return { ...i, isEnabled: !i.isEnabled };
      }
      return i;
    });

    dispatch({
      type: 'updateFormFields',
      formFieldUpdates: {
        [optionDescriptionGroup]: optionsUpdated,
      },
    });
  };

  return (
    <div className="flex flex-col">
      <span className="mb-6 font-bold text-2xl">{title}</span>
      <p className="text-sm" style={{ color: '#656F77' }}>{subTitle}</p>
      {options.map((o: DescriptionOptionField) => {
        const { id, name, isEnabled, group, groupText } = o;
        const shouldShowGroupText = Boolean(
          groupText && groupText !== lastGroupText,
        );
        if (shouldShowGroupText) {
          lastGroupText = groupText;
        }

        const displayName =
          id === 'saleswo#'
            ? 'Work Order #'
            : id === 'saleslining:no' || id === 'salesinterlining:no'
            ? 'Display "No" when not selected'
            : id === 'saleslining:yes' || id === 'salesinterlining:yes'
            ? 'Display "Yes" when selected'
            : id === 'salesembellishmentsselected'
            ? 'Embellishments'
            : name;

        // const index = indexMap[name] || '';
        // const trimmed = String(index).trim();
        // const isMulti = trimmed.includes(',') || trimmed.length > 1; // pill shape for "6, 7" / "8, 9" / "10"

        return (
          <React.Fragment key={id}>
            {shouldShowGroupText && <span className="font-bold text-lg">{groupText}</span>}
            <div
              className="flex flex-row items-center gap-2 mb-2"
              style={{ marginLeft: group ? '25px' : 0 }}
            >
              <Checkbox
                id={id}
                checked={isEnabled}
                onChange={toggleCheckbox}
                disabled={isEstimateSettingsReadOnly}
                uiDisabled={isEstimateSettingsReadOnly}
              />
              <div className="mr-1">{displayName}</div>
              {/* <span className={`badge ${isMulti ? 'multi' : ''}`}>{trimmed}</span> */}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

const DetailsDescription: FC<DetailsDescriptionProps> = ({
  title,
  subTitle,
  optionsGroupName,
  dispatch,
  draperyItemDetailsFields,
  isEstimateSettingsReadOnly,
}) => {
  return (
    <div className="mt-4">
      <div className="flex flex-col lg:flex-row justify-between">
        <OptionsComp
          title={title}
          optionsGroupName={optionsGroupName}
          draperyItemDetailsFields={draperyItemDetailsFields}
          dispatch={dispatch}
          subTitle={subTitle}
          isEstimateSettingsReadOnly={isEstimateSettingsReadOnly}
        />
        {/* <DetailsPreview title={title} /> */}
      </div>
    </div>
  );
};

export default DetailsDescription;
